// import { useState } from "react"
import { Card, Row, Col, Button } from "react-bootstrap"
import { useContext, useState } from "react"
import { ProfileContext } from "pages/Profile"
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { authActions } from '_store'
import StandardModal from 'components/general/defaultModals/StandardModal'
import { toast } from 'react-toastify'

export default function DeleteAccount() {

  const { profile } = useContext(ProfileContext)
  const url = process.env.REACT_APP_URL

  const dispatch = useDispatch()
  const { user: authUser } = useSelector(x => x.auth)
  const navigate = useNavigate()

  const [saveLoading, setSaveLoading] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const handleCloseModal = () => setShowDeleteModal(false)
  const handleShowModal = () => setShowDeleteModal(true)

  const deleteUserFromInstance = async () => {
    const response = await fetch(
      `${url}/users/${profile._id}`,
      {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`
        }
      }
    )
    const result = await response.json()
    if (!response.ok) {
      throw new Error(result?.Error || result?.message || `(${response.status}) Could not delete user`)
    }
    return result
  }

  const handleDelete = async (e) => {
    e.preventDefault()
    setSaveLoading(true)
    try {
      const deletingSelf = authUser.user._id === profile._id
      const result = await deleteUserFromInstance()
      if (deletingSelf) {
        dispatch(authActions.logout())
      }
      if (result) {
        navigate(`/users`)
      }
    } catch (error) {
      toast.error(String(error?.message || error), { position: 'bottom-left' })
    } finally {
      setSaveLoading(false)
    }
  }


  return (
    <Card className="mt-3 mb-3 user-card settings-card meetings-mock-card-shell meetings-page-card">
      <Card.Header className="settings-card-header">
        <Row className="mt-2 mb-2"><Col>Delete account for {profile.firstName} {profile.lastName}</Col></Row>
      </Card.Header>
      <Card.Footer className="settings-card-footer">
        <Row className="mt-2 mb-2">
          <Col className="text-center"><Button variant="danger" className="settings-danger-btn" onClick={handleShowModal}>Delete Account</Button></Col>
        </Row>
      </Card.Footer>

      <StandardModal
        show={showDeleteModal}
        handleClose={handleCloseModal}
        title="Delete Account"
        ModalBodyComponent={(
          <div className="text-center">
            <h4 className="mb-2">Delete user:</h4>
            <p className="mb-2" style={{ fontSize: '1.1rem', fontWeight: 700 }}>{profile.firstName} {profile.lastName}</p>
            <p className="mb-0">Are you sure you want to delete this user?</p>
          </div>
        )}
        ModalFooterComponent={(
          saveLoading
            ? 'Deleting User... '
            : (
              <>
                <Button variant='danger' type='submit' onClick={handleDelete}>
                  Delete User
                </Button>
                <Button variant='secondary' onClick={handleCloseModal}>
                  Cancel
                </Button>
              </>
            )
        )}
      />
    </Card>
  )
}